import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7d65da4f")

_pushScopeId("data-v-7d65da4f")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "description" }, [
  /*#__PURE__*/_createVNode("ul", null, [
    /*#__PURE__*/_createVNode("li", { class: "title" }, [
      /*#__PURE__*/_createVNode("h5", null, "操作指南：")
    ]),
    /*#__PURE__*/_createVNode("li", null, "1.在商户管理中绑定criteo账号"),
    /*#__PURE__*/_createVNode("li", null, "2.选择商品生成Feed链接，将链接复制同步至criteo"),
    /*#__PURE__*/_createVNode("li", null, " 3.词库管理可将商品标题中的敏感词进行替换，可以设置与默认词库相同的敏感词以编辑替换词汇 "),
    /*#__PURE__*/_createVNode("li", null, "4.受众管理可将跨境CRM插件中的会员标签及会员同步至已绑定的criteo账号")
  ])
], -1)
const _hoisted_3 = { class: "images" }
const _hoisted_4 = { class: "btn" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_page_header = _resolveComponent("m-page-header")
  const _component_m_image_preview = _resolveComponent("m-image-preview")
  const _component_el_button = _resolveComponent("el-button")
  const _component_m_form_skeleton = _resolveComponent("m-form-skeleton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", null, [
      _createVNode(_component_m_page_header, { title: "操作指南" })
    ]),
    _createVNode("main", null, [
      _createVNode(_component_m_form_skeleton, {
        loading: $setup.loading,
        type: "text"
      }, {
        default: _withId(() => [
          _hoisted_2,
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_m_image_preview, {
              imgList: [$setup.homePreview1, $setup.homePreview2, $setup.homePreview3, $setup.homePreview4]
            }, null, 8, ["imgList"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: $setup.isInstall ? 'danger' : 'primary',
              onClick: $setup.setPlugin,
              loading: $setup.btnLoading,
              size: "medium"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString($setup.isInstall ? '卸载插件' : '安装插件'), 1)
              ]),
              _: 1
            }, 8, ["type", "onClick", "loading"])
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ]))
})